<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="80" class="search-form">
              <Form-item label="编号" prop="id">
                <Input type="text" v-model="searchForm.id" placeholder="请输入编号" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="监测类型" prop="type">
                <Select v-model="searchForm.type" style="width: 200px">
                  <Option value="">全部</Option>
                  <Option value="image">图片</Option>
                  <Option value="music">音乐</Option>
                  <Option value="word">文字</Option>
                </Select>
              </Form-item>
              <Form-item label="监测名称" prop="monitorName">
                <Input type="text" v-model="searchForm.monitorName" placeholder="请输入监测名称" clearable style="width: 200px"/>
              </Form-item>
              <span v-if="drop">
              <br/>
              <Form-item label="用户id" prop="registerId">
                <Input type="text" v-model="searchForm.registerId" placeholder="请输入用户id" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="用户名称" prop="registerName">
                <Input type="text" v-model="searchForm.registerName" placeholder="请输入用户名称" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="用户手机号" prop="registerMobilePhone">
                <Input type="text" v-model="searchForm.registerMobilePhone" placeholder="请输入用户手机号" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="用户邮箱" prop="registerEmail">
                <Input type="text" v-model="searchForm.registerEmail" placeholder="请输入用户邮箱" clearable style="width: 200px"/>
              </Form-item>
              <br/>
              <Form-item label="监测提交时间" prop="createDate">
                <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
              </Form-item>
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
        <FormItem label="编号" prop="id" >
          {{form.id}}
        </FormItem>
        <FormItem label="用户id" prop="registerId" >
          {{form.registerId}}
        </FormItem>
        <FormItem label="用户名称" prop="registerName" >
          {{form.registerName}}
        </FormItem>
        <FormItem label="用户手机号" prop="registerMobilePhone" >
          {{form.registerMobilePhone}}
        </FormItem>
        <FormItem label="用户邮箱" prop="registerEmail" >
          {{form.registerEmail}}
        </FormItem>
        <FormItem label="监测类型" prop="type" >
          <div v-if="form.type == 'image'">
            图片
          </div>
          <div v-if="form.type == 'music'">
            音乐
          </div>
          <div v-if="form.type == 'word'">
            文字
          </div>
        </FormItem>
        <!--<FormItem label="DIC登记号" prop="dicCode" >-->
          <!--<Input v-model="form.dicCode" style="width:100%"/>-->
        <!--</FormItem>-->
        <!--<FormItem label="DIC证书" prop="dicCert" >-->
          <!--<Input v-model="form.dicCert" style="width:100%"/>-->
        <!--</FormItem>-->
        <FormItem label="监测名称" prop="monitorName" >
          {{form.monitorName}}
        </FormItem>
        <FormItem label="监测范围" prop="scopeIds" >
          <span v-for="(scope,i) in form.scopeStr">{{scope}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </FormItem>
        <FormItem label="提交时间" prop="createDate" >
          {{form.createDate}}
        </FormItem>
        <FormItem label="作品图片" prop="workImage" v-if="form.type == 'image'">
          <a :href="''+form.workImage+''" target="_blank">{{form.workImage}}</a>
        </FormItem>
        <FormItem label="文本内容" prop="textContent" v-if="form.type == 'word'">
          {{form.textContent}}
        </FormItem>
        <FormItem label="音乐名称" prop="musicName" v-if="form.type == 'music'">
          {{form.musicName}}
        </FormItem>
        <FormItem label="音乐作者" prop="musicAuthor" v-if="form.type == 'music'">
          {{form.musicAuthor}}
        </FormItem>
        <FormItem label="监测开始时间" prop="startTime" >
          {{form.startTime}}
        </FormItem>
        <FormItem label="监测结束时间" prop="endTime" >
          {{form.endTime}}
        </FormItem>
        <FormItem label="监测报告" prop="reportUrl" >
          <a :href="''+form.reportUrl+''" target="_blank">{{form.reportUrl}}</a>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "CopyrightMonitorContent",
  components: {
  },
  data() {
    return {
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "a.update_date", // 默认排序字段
        order: "desc", // 默认排序方式
      },
      form: { // 添加或编辑表单对象初始化数据
        id: "",
        type: "",
        dicCode: "",
        dicCert: "",
        workImage: "",
        textContent: "",
        musicName: "",
        musicAuthor: "",
        monitorName: "",
        scopeIds: "",
        remarks: "",
        registerId: "",
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "编号",
          key: "id",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "用户id",
          key: "registerId",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "用户名称",
          key: "registerName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "用户手机号",
          key: "registerMobilePhone",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "用户邮箱",
          key: "registerEmail",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "监测类型",
          key: "type",
          minWidth: 120,
          sortable: false,
          render(h, params){
            let type = '';
            let style = '';
            switch (params.row.type){
              case 'image':
                type = '图片';
                break;
              case 'music':
                type = '音乐';
                break;
              case 'word':
                type = '文字';
                break;
              default:
                break;
            }
            return h('span', {}, type);
          }
        },
//        {
//          title: "DIC登记号",
//          key: "dicCode",
//          minWidth: 120,
//          sortable: false,
//        },
//        {
//          title: "DIC证书",
//          key: "dicCert",
//          minWidth: 120,
//          sortable: false,
//        },
        {
          title: "作品图片",
          key: "workImage",
          minWidth: 120,
          sortable: false,
          render(h, params){
            let attrs = {href: params.row.workImage};
            return h('a', {
              attrs: attrs
            }, params.row.workImage);
          }
        },
        {
          title: "文本内容",
          key: "textContent",
          minWidth: 200,
          sortable: false,
          render: (h, params) => {
            let texts = '';                                       //表格列显示文字
            if (params.row.textContent!== null) {
              if (params.row.textContent.length > 200) {                    //进行截取列显示字数
                texts = params.row.textContent.substring(0, 200) + "...";
              } else {
                texts = params.row.textContent;
              }
            }
            return h('Tooltip', {
              props: {
                placement: 'top'
              }
            }, [
              texts,
              h('span', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, params.row.textContent)
            ])
          }
        },
        {
          title: "音乐名称",
          key: "musicName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "音乐作者",
          key: "musicAuthor",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "监测名称",
          key: "monitorName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "监测范围",
          key: "scopeStr",
          minWidth: 120,
          sortable: false,
          render(h, params){
            var arr = params.row.scopeStr;
            return h('ul', arr.map(function (item,index) {
              return h('span',{}, item)
            }));
          }
        },
        {
          title: "监测提交时间",
          key: "createDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "监测开始时间",
          key: "startTime",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "监测结束时间",
          key: "endTime",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "监测数量",
          key: "monitorNumber",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "传播数量",
          key: "spreadNumber",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "监测报告",
          key: "reportUrl",
          minWidth: 120,
          sortable: false,
          render(h, params){
            let attrs = {href: params.row.reportUrl};
            return h('a', {
              attrs: attrs
            }, params.row.reportUrl);
          }
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          fixed: 'right',
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    }
                  }
                },
                "详情"
              )
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
       this.getRequest("/copyrightMonitorContent/getByPage", this.searchForm).then(res => {
         this.loading = false;
         if (res.success) {
           this.data = res.result.records;
           this.total = res.result.total;
         }
       });
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          } else {
            // 编辑
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "详情";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.name + " ?",
        loading: true,
        onOk: () => {
          // 删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + v.id).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + ids).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.clearSelectAll();
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.clearSelectAll();
          this.getDataList();
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>